import hertzLogo from './HertzLogo.png';
import DollarLogo from './DollarLogo.png';
import ThriftyLogo from './ThriftyLogo.png';
import FooterImg from './footerImg.png';

const images = {
    hertzLogo,
    DollarLogo,
    ThriftyLogo,
    FooterImg,
}

export default images;
